import React from 'react';
import { useEmpresaSelecionada } from './useEmpresaSelecionada';
import PainelGar from './PainelGar';
import PainelNaoConformidade from './PainelNaoConformidade';
import PainelDenuncias from './PainelDenuncias';

const PainelEmpresa: React.FC = () => {
    const { empresas, empresaId, selecionar, carregando } = useEmpresaSelecionada();

    if (carregando || empresas.length === 0) {
        return null;
    }

    return (
        <div className='container bg-white p-5 rounded-4 w-90 mt-5'>
            {empresas.length > 1 && (
                <div className='row mb-5'>
                    <div className='col-md-4'>
                        <label className='form-label fw-bold text-dark fs-6'>Empresa</label>
                        <select
                            className='form-control form-control-lg form-control-solid'
                            value={empresaId === null ? '' : String(empresaId)}
                            onChange={(e) => selecionar(Number(e.target.value))}
                        >
                            {empresas.map((empresa) => (
                                <option key={empresa.value} value={empresa.value}>
                                    {empresa.text}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            )}

            {empresaId !== null && (
                <div className='row'>
                    <PainelGar empresaId={empresaId} />
                    <PainelNaoConformidade empresaId={empresaId} />
                    <PainelDenuncias empresaId={empresaId} />
                </div>
            )}
        </div>
    );
};

export default PainelEmpresa;
